import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path} from 'react-native-svg';
import Styles from 'src/components/Styles';
type LogoProps = {
  size: number;
  style?: Record<string, unknown>;
}; // tslint:disable

export default class PaperBillCompany extends React.Component<LogoProps> {
  getWidth() {
    if (this.props.style && this.props.style['size']['width']) {
      return this.props.style['size']['width'];
    } else {
      return 51;
    }
  }

  getHeight() {
    if (this.props.style && this.props.style['size']['height']) {
      return this.props.style['size']['height'];
    } else {
      return 32;
    }
  }

  render() {
    return (
      <>
        <Svg
          width={this.getWidth()}
          height={this.getHeight()}
          viewBox="0 0 28 29"
          fill="none"
        >
          <G clipPath="url(#clip0_3252_1857)">
            <Path
              d="M22.417 8.563c.645 0 1.166.53 1.166 1.187v1.188c-1.287 0-2.333-1.066-2.333-2.376h1.167zm-14 0h11.666c0 1.966 1.568 3.562 3.5 3.562v4.75c-1.932 0-3.5 1.596-3.5 3.563H8.417c0-1.967-1.568-3.563-3.5-3.563v-4.75c1.932 0 3.5-1.596 3.5-3.563zm-3.5 9.5c1.287 0 2.333 1.065 2.333 2.375H6.083c-.645 0-1.166-.531-1.166-1.188v-1.188zm16.333 2.375c0-1.31 1.046-2.375 2.333-2.375v1.187c0 .657-.521 1.188-1.166 1.188H21.25zm-14-11.875c0 1.31-1.046 2.374-2.333 2.374V9.75c0-.657.521-1.188 1.166-1.188H7.25zM6.083 7.375C4.796 7.375 3.75 8.44 3.75 9.75v9.5c0 1.31 1.046 2.375 2.333 2.375h16.334c1.287 0 2.333-1.065 2.333-2.375v-9.5c0-1.31-1.046-2.375-2.333-2.375H6.083zm7 5.344a.59.59 0 00.584.594v2.374h-.292a.59.59 0 00-.583.594.59.59 0 00.583.594h1.75a.59.59 0 00.583-.594.59.59 0 00-.583-.593h-.292v-2.97a.59.59 0 00-.583-.593h-.583a.59.59 0 00-.584.594zM10.75 14.5c0-.945.369-1.851 1.025-2.52a3.47 3.47 0 012.475-1.043 3.47 3.47 0 012.475 1.044A3.595 3.595 0 0117.75 14.5c0 .945-.369 1.851-1.025 2.52a3.47 3.47 0 01-2.475 1.043 3.47 3.47 0 01-2.475-1.044A3.595 3.595 0 0110.75 14.5zm8.167 0c0-1.26-.492-2.468-1.367-3.359a4.625 4.625 0 00-3.3-1.391c-1.238 0-2.425.5-3.3 1.391A4.793 4.793 0 009.583 14.5c0 1.26.492 2.468 1.367 3.359a4.625 4.625 0 003.3 1.391c1.238 0 2.425-.5 3.3-1.391a4.793 4.793 0 001.367-3.359z"
              fill={Styles.Colors.CompanyKitchen.blue}
            />
          </G>
          <Defs>
            <ClipPath id="clip0_3252_1857">
              <Path
                fill="#fff"
                transform="translate(3.75 5)"
                d="M0 0H21V19H0z"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </>
    );
  }
}

